import { I18nProvider } from 'react-admin';
import { useTranslation } from 'react-i18next';

export const useI18nextProvider = (): I18nProvider => {
  const { i18n, t } = useTranslation();
  const i18nProvider = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    changeLocale: async (locale: string, options: any) => {
      await i18n.changeLanguage(locale, options);
    },

    getLocale: () => i18n.language,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    translate: (key: string, options: any = {}) => {
      const { _: defaultValue, ...otherOptions } = options || {};
      return t(key, {
        count: options.smart_count,
        defaultValue,
        ns: 'admin',
        ...otherOptions,
      });
    },
  };
  return i18nProvider;
};
